import { useIntervalFn } from '@vueuse/core';

export async function useTypewriter(targetText, options = {}) {
  const typingSpeed = options.typingSpeed || 50;
  const onTyping = options.onTyping;

  const output = ref('');
  const chunks = ref([]);
  const index = ref(0);

  let resolveDone;

  function splitHtmlAware(text) {
    const regex = /(<[^>]+>|[^<])/g; // match tags or single characters
    return text.match(regex) || [];
  }

  chunks.value = splitHtmlAware(targetText);

  const { pause, resume, isActive } = useIntervalFn(() => {
    if (index.value < chunks.value.length) {
      output.value += chunks.value[index.value];
      if (typeof onTyping === 'function') {
        onTyping(output.value);
      }
      index.value++;
    } else {
      pause();
      if (resolveDone) {
        resolveDone();
        resolveDone = null;
      }
    }
  }, typingSpeed, { immediate: false });

  const done = new Promise((resolve) => {
    resolveDone = resolve;
    resume();
  });

  await done;

  return {
    output,
    isTyping: isActive,
    pause,
    resume,
  };
}
